module.exports = __webpack_public_path__ + "static/img/yucunyouli.aa410967.png";